import styled from 'styled-components';

export const Text = styled.div`
  color: red;
  font-size: 14px;
`;
